import { create } from "zustand";

interface FailedEmbedsState {
  addFailedLinkEmbed: (url: string) => void;
  failedLinkEmbeds: string[];
}

export const useFailedEmbedsStore = create<FailedEmbedsState>(set => ({
  failedLinkEmbeds: [],

  addFailedLinkEmbed: url => {
    set(state => ({
      failedLinkEmbeds: [...state.failedLinkEmbeds, url],
    }));
  },
}));
